module.exports = __webpack_public_path__ + "img/partner16.3ad47ce6.png";